import { Roles } from '@/types';

export type LoginCredentials = {
  email: string;
  password: string;
  registrationToken: string;
  operatingSystem: string;
};

export type RegisterCredentials = {
  email: string;
  password: string;
  confirmPassword: string;
  name: string;
};

export type UpdateCredentials = {
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  bio?: string;
};

export type User = {
  id: string;
  email: string;
  name: string;
  cpf: string;
  rg: string;
  phone?: string;
  carteiraId: string;
  createdAt?: Date;
  updatedAt?: Date;
  imageUser?: string;
  role: Roles;
};

export type UserResponse = {
  accessToken: string;
  user: User;
};

enum TypeAuth {
  facebook = 'facebook',
  password = 'password',
  refreshToken = 'refresh_token',
}

export type AuthResponse = {
  accessToken: string;
  refreshToken: string;
  fbPicture: string;
};

export type AuthInput = {
  user: string;
  password: string;
  type: TypeAuth;
};
